import React from 'react'
import { Text, View } from 'react-native'
import { FeaturesSection } from '../components/HomeSections'
import { useThemeValue } from '../ThemeContext'
import { baseFont, HEADER_HEIGHT } from '../utils/ui'
import { Container, Reveal, Section } from '../components/ui'

export function FeaturesPage() {
  const { theme } = useThemeValue()
  return (
    <View>
      <Section background={theme.colors.background} paddingTop={HEADER_HEIGHT + 40} paddingBottom={32}>
        <Container>
          <Reveal>
            <View style={{ alignItems: 'center', gap: 20 }}>
              <Text style={{ ...baseFont('700'), color: theme.colors.text, fontSize: 56, lineHeight: 64, letterSpacing: -2, textAlign: 'center' }}>
                Call handling that feels <Text style={{ color: theme.colors.primary }}>simple</Text>
              </Text>
              <Text style={{ ...baseFont('500'), color: theme.colors.inactive, fontSize: 20, lineHeight: 32, textAlign: 'center', maxWidth: 760 }}>
                From blocking spam to booking appointments, Relayably helps you stay available without needing technical setup.
              </Text>
            </View>
          </Reveal>
        </Container>
      </Section>
      <FeaturesSection />
    </View>
  )
}
